import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { QuickFilterButton } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

var StoreSearchFilterItemContainer = (_param)=>{
    var { className , filterKey , filter , setFilterActivity  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "filterKey",
        "filter",
        "setFilterActivity"
    ]);
    const { getFormattedLabel  } = useIntl();
    const onClick = React.useCallback(()=>setFilterActivity(filterKey, !filter.active)
    , [
        filterKey,
        filter,
        setFilterActivity
    ]);
    return /*#__PURE__*/ React.createElement(QuickFilterButton, swcHelpers.extends({}, rest, {
        label: filter.label,
        ariaLabels: {
            active: getFormattedLabel(`stores.component.storeFinder.filter.active`, {
                labelData: {
                    filter: filter.label
                }
            }),
            inactive: getFormattedLabel(`stores.component.storeFinder.filter.inactive`, {
                labelData: {
                    filter: filter.label
                }
            })
        },
        active: filter.active,
        onClick: onClick
    }));
};
var StoreSearchFilterItemContainer$1 = StoreSearchFilterItemContainer;

export { StoreSearchFilterItemContainer, StoreSearchFilterItemContainer$1 as default };
//# sourceMappingURL=StoreSearchFilterItemContainer.js.map
